import { RouteObject } from "react-router-dom";
import { lazy } from "react";

const HomePage = lazy(() => import("../pages/home/page"));
const LearnMorePage = lazy(() => import("../pages/learn-more/page"));
// const QuickStartPage = lazy(() => import("../pages/quick-start/page"));
const RMAPage = lazy(() => import("../pages/rma/page"));
// const NewsPage = lazy(() => import("../pages/news/page"));
const NotFoundPage = lazy(() => import("../pages/NotFound"));
const TermsPage = lazy(() => import("../pages/term/page"));
const ContactPage = lazy(() => import("../pages/contact/page"));

const routes: RouteObject[] = [
  { path: "/", element: <HomePage /> },
  { path: "/learn-more", element: <LearnMorePage /> },
  // { path: "/quick-start", element: <QuickStartPage /> },
  { path: "/rma", element: <RMAPage /> },
  // { path: "/news", element: <NewsPage /> },
  { path: "/terms", element: <TermsPage /> },
  { path: "/contact", element: <ContactPage /> },
  { path: "*", element: <NotFoundPage /> },
];

export default routes;
